import type { IService } from "../BuhPage/BuhPage";

export interface IAllowFields {
  bio?: boolean;
  epitafia?: boolean;
  gallery?: boolean;
  video?: boolean;
  map?: boolean;
  media?: boolean;
  qr?: boolean;
  tree?: boolean;
  bg?: boolean;
  customImage?: boolean;
  solder?: boolean;
}

export interface ITarriff {
  allowFields: IAllowFields;
  createdAt: string;
  hide: boolean;
  id: number;
  name: string;
  price: number;
  updatedAt: string;
}

export type AnketaTextImageBlock = {
  name: string;
  text: string;
  images: { buffer?: File; src: string }[];
};

export interface IAnketa {
  id?: string;
  name: string;
  rang: string;
  photo: { buffer?: File; src: string };
  bg: { buffer?: File; src: string };
  dateBorn: string;
  dateEnd: string;
  years: string;
  quote: string;
  quoteName: string;
  createdAt: string;
  subData: {
    placeBorn: string;
    placeEnd: string;
    brothers: string;
    children: string;
    placeLive: string;
    parents: string;
    partner: string;
    education: string;
  };
  bio: AnketaTextImageBlock[];
  user: any;
  gallery: { buffer?: File; src: string }[];
  video: { src: string; buffer?: File; type?: string };
  graveyard: {
    description: string;
    name: string;
  };
  userId: number | null;
  mediaLinks: string[];
  socialLinks: string[];
  QRImage: { buffer?: File; src: string };
  customImage: { buffer?: File; src: string; width?: number; height?: number };
  customImageText: string;
  customImageText2: string;
  customImageText3: string;
  comment: string;
  customQRCode: {
    type: string;
    color?: string;
    cornersType?: string;
    cornersColor?: string;
  };
  hidden: boolean;
  orders: any[];
  isTrial: boolean;
  isSolder: boolean;
  status: string;
  honor: AnketaTextImageBlock[];
  honorWay: AnketaTextImageBlock[];
  tree: any[];
  orderStatus: string;
  tariffId?: string;
  orderId?: string;
  coordinates?: {
    address: string;
    coords: string[];
  };
  AnketaService?: AnketaService[];
}

export interface AnketaService {
  anketaId: string;
  price: number;
  service: IService;
  serviceId: string;
  title: string;
  type: string;
}

export const initialState: IAnketa = {
  name: "",
  rang: "",
  createdAt: "",
  photo: { src: "" },
  bg: { src: "" },
  dateBorn: "",
  dateEnd: "",
  years: "",
  quote: "",
  quoteName: "",
  comment: "",
  subData: {
    placeBorn: "",
    placeEnd: "",
    brothers: "",
    children: "",
    placeLive: "",
    parents: "",
    partner: "",
    education: "",
  },
  bio: [],
  user: {},
  gallery: [],
  video: { src: "" },
  graveyard: {
    description: "",
    name: "",
  },
  userId: null,
  mediaLinks: [],
  socialLinks: [],
  QRImage: { src: "" },
  hidden: false,
  orders: [],
  isTrial: false,
  isSolder: false,
  status: "PENDING_REVIEW",
  honor: [],
  honorWay: [],
  tree: [],
  orderStatus: "NEW",
  customImage: { src: "" },
  customImageText: "",
  customImageText2: "",
  customImageText3: "",
  customQRCode: {
    type: "square",
    color: "#000000",
    cornersType: "square",
    cornersColor: "#00000",
  },
  AnketaService: [],
};

export type IRelationsResult = {
  anketa: IAnketa;
  relation: string;
  position: number;
};

export interface ITree {
  id: string;
  anketaToId: string;
  anketaId: string;
  name: string;
  position: number;
  status: string;
}
